module.exports = __webpack_public_path__ + "img/H4.672c0398.png";